import { useAppDispatch } from "../redux/hooks";
import { CountryInfoType } from "../country/redux/country.types";
import { useSelector } from "react-redux";
import { selectedCountrySelector } from "../country/redux/country.selector";
import { showPageLoaderSelector } from "../shared/redux/shared.selector";
import { useEffect } from "react";
import { genericActionDispatcher } from "../shared/redux/shared.slice";

// Components imports
import HeaderComponent from "../shared/components/header/header.component";
import FooterComponent from "../shared/components/footer/footer.component";
import RaiseTaxBodyComponent from "./raise-tax-body.component";
import LoaderComponent from "../shared/components/loader.component";

// Logo and image import
import mpowerLogoRaiseTax from "../assets/logo/mpower-logo-raise-tax.png";
import WhoBlueLogo from "../assets/logo/who-logo-blue.png";

//Interface import
import { HeaderPropType } from "../shared/components/header/header-interface";

const headerPropData: HeaderPropType[] = [
    {
        id: "01",
        img: WhoBlueLogo,
        alt: "who-blue-logo",
        class: "whologo",
        url: "",
    },
    {
        id: "02",
        img: mpowerLogoRaiseTax,
        alt: "mpower-raise-tax-logo",
        class: "mpowerlogo",
        url: "/",
    },
];

const RaiseTaxPage = (): React.JSX.Element => {
    const dispatch = useAppDispatch();
    const selectedCountry: CountryInfoType = useSelector(
        selectedCountrySelector,
    );
    const showLoader = useSelector(showPageLoaderSelector);

    useEffect(() => {
        dispatch(
            genericActionDispatcher({
                selectedCountry: selectedCountry?.raiseTaxBlockPropData?.name,
                policyData: "6",
            }),
        );
    }, []);

    return (
        <>
            {showLoader ? (
                <LoaderComponent></LoaderComponent>
            ) : (
                <>
                    <HeaderComponent imgData={headerPropData} />
                    <RaiseTaxBodyComponent />
                    <FooterComponent />
                </>
            )}
        </>
    );
};

export default RaiseTaxPage;
